import * as requestFromServer from "./PersonnelTypesCrud";
import { callTypes, personnelTypeSlice } from "./PersonnelTypesSlice";

const {actions} = personnelTypeSlice;

export const getPersonnelTypes = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getPersonnelTypes(queryParams)
    .then(response => {
      dispatch(actions.personnelTypesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllPersonnelTypes = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllPersonnelTypes(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getPersonnelType = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewPersonnelType()
    .then(response => {
      dispatch(actions.personnelTypeFetched(response.data));
    })
    .catch(error => {
      
    });
  }

  return requestFromServer
    .getPersonnelType(id)
    .then(response => {
      dispatch(actions.personnelTypeFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const savePersonnelType = personnelType => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .savePersonnelType(personnelType)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deletePersonnelTypes = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deletePersonnelTypes(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanPersonnelTypesState = () => dispatch => {
  dispatch(actions.personnelTypesStateCleaned());
}